import { fetchGET } from "../utils/handler_http";

/**
 * Obtener conductores activos en línea y viajes en transcurso
 * para el mapa de monitoreo en tiempo real
 */
export const getLiveMapData = async (jwt = "") => {
  const endpoint =
    process.env.REACT_APP_ADMIN_LIVE_MAP_ENDPOINT ||
    (process.env.REACT_APP_ADMIN_ENDPOINT
      ? process.env.REACT_APP_ADMIN_ENDPOINT.replace(
          /\/admin$/,
          "/admin-live-map"
        )
      : "");
  return fetchGET(
    endpoint,
    {},
    { Authorization: jwt },
  );
};

/**
 * Obtener coordenadas de origen de viajes del histórico para mapa de demanda
 */
export const getTripOriginsData = async (period = "day", status = "all", jwt = "") => {
  const base = process.env.REACT_APP_ADMIN_ENDPOINT || "";
  const endpoint = base ? `${base}/trip-origins` : "";
  return fetchGET(
    endpoint,
    { period, status },
    { Authorization: jwt }
  );
};
